import type { Mention } from "shared/types/mentions";

export interface ExclusionResults {
  excludedItemIds: string[];
  excludedSyndicationKeys: string[];
  excludedTimeBundleKeys: string[];
}

export function getExcludedKeys(
  mentions: Mention[],
  bundleBroadcast: boolean,
  collapseSyndicated: boolean
): ExclusionResults {
  const results: ExclusionResults = {
    excludedItemIds: [],
    excludedSyndicationKeys: [],
    excludedTimeBundleKeys: [],
  };

  if (mentions.length === 0) {
    return results;
  }

  if (bundleBroadcast) {
    results.excludedTimeBundleKeys = mentions.map(
      (mention) => mention.time_bundle_key
    );

    return results;
  }

  if (collapseSyndicated) {
    results.excludedSyndicationKeys = mentions.map(
      (mention) => mention.syndication_key
    );

    return results;
  }

  results.excludedItemIds = mentions.map(
    (mention) => `${mention.type}_${mention.id}`
  );

  return results;
}
